package com.kaihuoy.home.screens

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.shared.data.User
import com.kaihuoy.components.common.*
import com.kaihuoy.components.common.*
import com.kaihuoy.web.router.AppRouterState

@Composable
fun InspectionScreen(user: User?, onLogout: () -> Unit) {
    PageLayout(greeting = getGreeting(user?.displayName), onLogout = onLogout) {
    Div(attrs = { style { padding(32.px, screenContentPadding()) } }) {

        H1(attrs = { style { marginBottom(8.px) } }) {
            Text("Kaluston tarkastus")
        }

        P(attrs = {
            style {
                marginBottom(32.px)
                color(KaihuTheme.TextSecondary)
                fontSize(1.05.em)
            }
        }) {
            Text("Koneet, laitteet ja työkalut")
        }

        Div(attrs = {
            style {
                display(DisplayStyle.Grid)
                gridTemplateColumns("repeat(auto-fill, minmax(min(280px, 100%), 1fr))")
                gap(24.px)
            }
        }) {
            // Uusi tarkastus
            DashboardCard(
                title = "Uusi tarkastus",
                subtitle = "Aloita koneen tai laitteen tarkastus",
                icon = "tool",
                containerColor = KaihuTheme.CardBackground,
                onClick = {
                    AppRouterState.navigate("uusi_tarkastus")
                }
            )
        }
            // Omat tarkastukset
            /*DashboardCard(
                title = "Omat tarkastukset",
                subtitle = "Tarkastele tekemiäsi kirjauksia",
                icon = "clipboard-list",
                containerColor = KaihuTheme.CardBackground,
                onClick = {
                    AppRouterState.navigate("hallinta")
                }
            )

            // Kaikki tarkastukset (vain admin)
            if (user?.isAdmin == true) {
                DashboardCard(
                    title = "Kaikki tarkastukset",
                    subtitle = "Näytä kaikki tallennetut tarkastukset",
                    icon = "report-analytics",
                    containerColor = KaihuTheme.CardBackground,
                    onClick = {
                        // Admin-näkymä kaikista tarkastuksista
                    }
                )
            }*/
        }
    }
        // Info-alue
        Div(attrs = { style { marginTop(40.px); opacity(0.8) } }) {

        }

}